export const fhirUrls = {
  BIOMARKER: "http://molit.eu/fhir/vitu/ValueSet/biomarker",
  EVIDENCE_LEVEL: "http://molit.eu/fhir/vitu/ValueSet/evidence-level",
  RECOMMENDATION_CATEGORY: "http://molit.eu/fhir/vitu/ValueSet/recommendation-category",
  TREATMENT_CONTEXT: "http://molit.eu/fhir/vitu/ValueSet/treatment-context",
  TUMORBOARD_CANELLATION_REASON: "http://molit.eu/fhir/vitu/ValueSet/tumorboard-cancellation-reason",
  WORKING_LIST_STATUS: "http://molit.eu/fhir/vitu/ValueSet/working-list-status"
};
